import { supabase } from "../supabase/SupabaseClient";
import { FLOTABOT } from "../components/layout/secciones";

/* Cuál de las guías del bot le toca a quien está mirando el hub.
 *
 * Igna: «¿podemos hacer que dependiendo la persona que entra acá y los roles
 * que tiene lo mande a ver el howto que le corresponde?».
 *
 * ── POR QUÉ SE PREGUNTA Y NO SE DEDUCE ACÁ ──────────────────────────────────
 *
 * El hub tiene los permisos a mano y podría resolverlo solo: `ver.puerto` →
 * la guía de puerto, `ver.porteria` → la de portería. Sería una segunda copia
 * de una regla que ya existe, y —peor— **una copia que contestaría distinto**,
 * porque las dos cosas no son la misma:
 *
 *     los permisos del hub   dicen qué PANTALLAS ve alguien
 *     los roles de la planilla   deciden qué le contesta el BOT
 *
 * Se puede tener medio hub abierto y estar `solo_puerto` en WhatsApp. Mandar a
 * esa persona a la guía general sería darle una página entera de comandos que
 * el bot le rebota — que es exactamente el problema que las cuatro guías
 * separadas vinieron a resolver.
 *
 * Así que decide el bot, con la misma función que ya contesta el comando
 * `ayuda` por WhatsApp. Acá sólo se pregunta.
 *
 * ── EL TOKEN VA EN EL ENCABEZADO Y NO HAY PARÁMETRO ─────────────────────────
 *
 * No se manda el mail: el bot lo saca del token. Con un `?mail=` cualquiera
 * podría preguntar por cualquiera, y la respuesta dice si esa persona está en
 * la planilla y con qué clase de rol.
 *
 * ── SI NO SE PUEDE PREGUNTAR, NO SE INVENTA ─────────────────────────────────
 *
 * Red caída, CORS mal, panel apagado: devuelve `null`, y la pantalla muestra
 * el texto de siempre sin botón. Adivinar una guía sería mandar a alguien a
 * leer comandos que capaz no puede usar.
 */

export async function guiaQueMeToca() {
  try {
    const { data } = await supabase.auth.getSession();
    const token = data?.session?.access_token;
    if (!token) return null;

    const r = await fetch(`${FLOTABOT}/como/para`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!r.ok) return null;

    const g = await r.json();
    // Se valida la forma antes de devolverla: la pantalla dibuja un enlace con
    // esto, y un `url` que no vino deja un botón que no lleva a ningún lado.
    if (!g || typeof g !== "object") return null;
    if (g.tiene_whatsapp && !(g.url && g.titulo)) return null;
    return g;
  } catch (e) {
    return null;
  }
}
